import React from "react"

import Card from "react-bootstrap/Card"
import { useIntl } from "react-intl"

import Layout from "../components/layout"
import SEO from "../components/seo"
import PoliciesNavigation from "../components/policies_navigation"
import CardDeck from "../components/card_deck"
import FormattedMarkdown from "../components/formatted_markdown"

import iconfinder_20_3319624 from "../images/iconfinder_20_3319624.png"

const PoliciesPage = ({ location }) => {
  const intl = useIntl()
  const pageTitle = intl.formatMessage({ id: "Policies" })
  return (
    <Layout pageTitle={pageTitle} location={location}>
      <SEO title={pageTitle} />
      <PoliciesNavigation location={location} />
      <CardDeck>
        <PoliciesCard id="Policies" img={iconfinder_20_3319624} />
        <Card style={{ visibility: "hidden" }} />
        <Card style={{ visibility: "hidden" }} />
      </CardDeck>
    </Layout>
  )
}

const PoliciesCard = props => {
  const intl = useIntl()
  return (
    <Card>
      <Card.Img src={props.img} />
      <Card.Body>
        <Card.Title>{intl.formatMessage({ id: props.id })}</Card.Title>
        <Card.Text>
          <FormattedMarkdown id={"Policies." + props.id} />
        </Card.Text>
      </Card.Body>
    </Card>
  )
}

export default PoliciesPage
